import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cls from 'classnames';

import styles from './ActionButton.scss';

class ActionButton extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func.isRequired,
    iconNode: PropTypes.func,
    className: PropTypes.string,
    dataLocator: PropTypes.string,
  };

  render() {
    const { children, className, onClick, iconNode: Icon, dataLocator } = this.props;
    return (
      <button
        type="button"
        className={cls(styles.ActionButton, className)}
        onClick={onClick}
        data-locator={dataLocator}
      >
        {Icon ? <Icon className={styles.icon} /> : null}
        {children}
      </button>
    );
  }
}

export default ActionButton;
